module.exports = __webpack_public_path__ + "img/3.b0a2f760.png";